import React, { Component } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import Octicon, {X} from '@github/octicons-react';

export default class CloseControl extends Component {
  handleClose = () => {
    this.props.shell.shellInterface.toggleDetails();
  }

  render() {
    return (
      <ButtonGroup size="sm" className="header-options">
        <Button variant="light" onClick={this.handleClose}><Octicon icon={X}/></Button>
      </ButtonGroup>
    );
  }
}
